import axios from "axios";
import { City } from "../Classes/CityItem";
import { plainToInstance } from "class-transformer";
const url = "/api/cities";

export const axiosGetAllCities = async (): Promise<City[]> => {
  const response = await axios.get(url);
  const city = plainToInstance(City, response.data, {
    excludeExtraneousValues: true,
  });
  return city;
};
